import { Box } from '@mui/material';
import { FC } from 'react';

const containerSx = {
    alignItems: 'center',
    backgroundColor: 'primary.light',
    border: '1px solid',
    borderColor: 'primary.main',
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
};

const headerSx = {
    backgroundColor: 'action.selected',
    borderRadius: '4px 4px 0 0',
    color: 'secondary.main',
    px: 3,
    py: 1,
    textAlign: 'center',
    width: '100%',
};

const contentSx = {
    px: 3,
    py: 4,
    textAlign: 'center',
    width: '100%',
};

const backgroundSx = {
    background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, #FFF 100%)',
    mt: -8,
    position: 'relative',
    pt: 8,
};

interface CustomCardProps {
    dataTestId: string;
    headerContent?: React.ReactNode;
    mainContent: React.ReactNode;
    withFadeContent?: boolean;
}

const CustomCard: FC<CustomCardProps> = ({
    dataTestId,
    headerContent,
    mainContent,
    withFadeContent = false,
}) => (
    <Box data-test-id={dataTestId} sx={withFadeContent ? backgroundSx : {}}>
        <Box sx={containerSx}>
            <Box sx={headerSx}>{headerContent}</Box>
            <Box sx={contentSx}>{mainContent}</Box>
        </Box>
    </Box>
);

export default CustomCard;
